module.exports = __webpack_public_path__ + "static/media/TheCollectiveBecome-Medium.90787304.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TheCollectiveBecome-Medium.eot
// module id = 730
// module chunks = 0